import dynamic from 'next/dynamic'

const ProgressBar = dynamic(() => import('next-nprogress-bar').then(module => module.AppProgressBar))

export const NavigationProgressBar = () => {
  return <ProgressBar height="4px" options={{ showSpinner: false }} shallowRouting delay={300} />
}
